import { useContext, useEffect, useState } from 'react';
import { Menu, PositionType } from 'common/menu/menu';
import { AddLocationIcon, LocationIcon, SearchIcon } from 'assets/icons';
import { InputDropdownMenuItem } from 'common/input-dropdown-menu-item';
import { LocationModal } from 'common/modal-add-location';
import { classnames } from 'helpers/utils';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { VaultDetailContext } from 'context/vault-detail-context';
import styles from './location-menu.module.scss';

interface LocationMenuProps {
  addLocation: (newLocation: string) => void;
  renderInline?: boolean;
}

export const LocationMenu = ({
  addLocation,
  renderInline = false,
}: LocationMenuProps) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isNewLocationModalOpen, setIsNewLocationModalOpen] = useState(false);
  const [locations, setLocations] = useState<string[]>([]);
  const {
    state: { vaultId },
  } = useContext(VaultDetailContext);

  useEffect(() => {
    const fetchLocations = async () => {
      const fetchedLocations =
        await VaultsController.getAlbumLocations(vaultId);
      setLocations(fetchedLocations);
    };
    fetchLocations();
  }, []);

  const filteredLocations = locations?.filter((location) =>
    location.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const inner = (
    <div
      className={classnames(styles.container, {
        [styles.menuWidth]: renderInline,
      })}
    >
      <div className={styles.searchContainer}>
        <SearchIcon />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search location"
          className={styles.searchInput}
        />
      </div>

      <div className={styles.locationList}>
        <InputDropdownMenuItem
          leftIcon={<AddLocationIcon />}
          className={styles.newLocationButton}
          onClick={
            searchTerm
              ? () => addLocation(searchTerm)
              : () => setIsNewLocationModalOpen(true)
          }
        >
          {searchTerm ? `Create "${searchTerm}"` : 'New location'}
        </InputDropdownMenuItem>
        {filteredLocations.map((location) => (
          <InputDropdownMenuItem
            key={location}
            onClick={() => addLocation(location)}
            leftIcon={<LocationIcon />}
            className={styles.locationButton}
          >
            <span>{location}</span>
          </InputDropdownMenuItem>
        ))}
      </div>
    </div>
  );

  return (
    <>
      {renderInline ? (
        inner
      ) : (
        <Menu
          position={PositionType.BottomLeft}
          width={styles.menuWidth}
          className={styles.menu}
        >
          {inner}
        </Menu>
      )}
      {isNewLocationModalOpen && (
        <LocationModal
          onClose={() => setIsNewLocationModalOpen(false)}
          addNewLocation={addLocation}
          locationName={searchTerm}
        />
      )}
    </>
  );
};
